module.exports = __webpack_public_path__ + "img/pen.38050a0a.svg";